import React from 'react';
import { DOCS_STATUSES } from '../../config';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAdminSign,
  fetchClientSign,
  fetchExportDocuments,
  fetchGetFileClientSign,
} from '../../actions/documents';
import { showModal } from '../../actions/modal';
import { downloadFileViaDirectLink, parseError } from '../../helpers';
import { toast } from 'react-toastify';
import {
  cleanBase64,
  getCertificates,
  isCryptoProAvailable,
  signDocument,
} from '../../utils/criptoSignDocument';

const SignsBlock = ({ item }) => {
  const adminMode = localStorage.getItem('adminPanel');
  const account = useSelector((state) => state.auth.account);
  const dispatch = useDispatch();

  const handleAdminSign = (item) => {
    dispatch(fetchAdminSign({ id: item.humanId }));
  };
  const extractCN = (certInfo) => {
    const match = certInfo.match(/CN=([^;]+)/);
    return match ? match[1].trim() : null;
  };

  const handleClientApprove = async (item) => {
    if (!isCryptoProAvailable()) {
      toast.error('Не установлен плагин для электронной подписи');
      return;
    }
    try {
      const certs = await getCertificates();

      if (certs.length === 0) {
        toast.error('Сертификаты не найдены');

        return;
      } else if (certs.length === 1) {
        const certName = extractCN(certs[0].name);
        const documentBase64 = await dispatch(fetchGetFileClientSign(item.humanId));
        const signedBase64 = await signDocument(certName, documentBase64);
        dispatch(
          fetchClientSign({
            docId: item.humanId,
            signData: cleanBase64(signedBase64),
          }),
        );

        toast.info('Документ успешно подписан!');
      } else {
        dispatch(
          showModal('CertificatesModal', {
            certOptions: certs,
            selectedDoc: item,
            extractCN,
          }),
        );
      }
    } catch (err) {
      toast.error('Сертификаты не найдены ' + parseError(err));
    }
  };

  const handleClientReject = (item) => {
    dispatch(showModal('ClientComment', item));
  };

  const handleExportDocument = async (item) => {
    try {
      const res = await dispatch(
        fetchExportDocuments({
          docId: item.humanId,
        }),
      );
      downloadFileViaDirectLink(res.fileUrl, 'test');
    } catch (e) {}
  };

  const handleShowDocHistory = (item) => {
    dispatch(showModal('DocHistory', item));
  };

  return (
    <div>
      {(account.useJurEDI || account.useJurEDI !== null) &&
        (!item.hasOwnProperty('signClientLink') || item.signClientLink === null) &&
        (item.status !== DOCS_STATUSES.APPROVED_AUTO ||
          item.status !== DOCS_STATUSES.APPROVED_CLIENT ||
          item.status !== DOCS_STATUSES.SIGNED_CLIENT) &&
        item.signPerformerLink &&
        !account.ediAddress && (
          <i
            className="fe-check-circle edit-icon action-icon"
            style={{ color: 'green', cursor: 'pointer' }}
            title="Подписать"
            onClick={() => handleClientApprove(item)}
          />
        )}
      {(!item.hasOwnProperty('signClientLink') || item.signClientLink === null) &&
        (item.status !== DOCS_STATUSES.SIGNED_CLIENT ||
          item.status === DOCS_STATUSES.NOT_APPROVED ||
          item.status === DOCS_STATUSES.APPROVED_AUTO) &&
        (!item.signPermormerLink || false) && (
          <i
            className="fe-minus-circle edit-icon action-icon"
            style={{ color: 'red', cursor: 'pointer' }}
            title="Не согласен, сформировать тикет"
            onClick={() => handleClientReject(item)}
          />
        )}
      <i
        style={{ cursor: 'pointer' }}
        className="fe-arrow-down edit-icon action-icon"
        title="Экспорт данных в Excel"
        onClick={() => handleExportDocument(item)}
      />
      <i
        style={{ cursor: 'pointer' }}
        className="fe-clock edit-icon action-icon"
        title="История"
        onClick={() => handleShowDocHistory(item)}
      />
      {adminMode === 'true' &&
        item.status !== DOCS_STATUSES.SIGNED_PERFORMER &&
        (!item.signPermormerLink || false) && (
          <i
            style={{ color: '#7e57c3', cursor: 'pointer' }}
            className="fe-edit-2 edit-icon action-icon"
            title="Подписать за Исполнителя"
            onClick={() => handleAdminSign(item)}
          />
        )}
    </div>
  );
};

export default SignsBlock;
